import { render, staticRenderFns } from "./TextJoinItemEditDialog.vue?vue&type=template&id=a65e846e&scoped=true&"
import script from "./TextJoinItemEditDialog.vue?vue&type=script&lang=ts&"
export * from "./TextJoinItemEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TextJoinItemEditDialog.vue?vue&type=style&index=0&id=a65e846e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65e846e",
  null
  
)

export default component.exports